import React from 'react';
import NeonDivider from './NeonDivider';

const ContactSection = () => {
  return (
    <section id="contact" className="py-20 px-4 bg-gradient-to-b from-black via-black/95 to-black">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-logoSans text-ivory mb-4">
            VISIT US
          </h2>
          <p className="text-gray text-lg max-w-2xl mx-auto">
            Come experience the neon glow and legendary flavors in person. 
            We're ready to serve you the best wings in Scarborough.
          </p>
        </div>

        <NeonDivider color="neonBlue" />

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div className="space-y-8">
            {/* Location */}
            <div className="p-6 border border-neonBlue/20 rounded-xl bg-black/30 backdrop-blur-sm">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 bg-neonBlue/10 rounded-full flex items-center justify-center">
                  <svg className="w-6 h-6 text-neonBlue" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <h3 className="text-xl font-logoSans text-ivory">Location</h3>
              </div>
              <div className="text-gray">
                <p className="mb-2">3490 Kingston Rd</p>
                <p className="mb-2">Scarborough, ON M1M 1R5</p>
                <p className="text-sm">Near Kingston Road & McCowan</p>
              </div>
              <a
                href="https://maps.app.goo.gl/X8SdCHyZtU65jmyF8"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center mt-4 text-neonBlue hover:text-ivory transition-colors duration-200 font-semibold"
              >
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
                </svg>
                Get Directions
                <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </a>
            </div>

            {/* Hours */}
            <div className="p-6 border border-neonRed/20 rounded-xl bg-black/30 backdrop-blur-sm">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 bg-neonRed/10 rounded-full flex items-center justify-center">
                  <svg className="w-6 h-6 text-neonRed" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h3 className="text-xl font-logoSans text-ivory">Hours</h3>
              </div>
              <div className="space-y-2 text-gray text-sm sm:text-base">
                <div className="flex justify-between items-center">
                  <span className="flex-shrink-0">Sun–Tue</span>
                  <span className="text-neonRed font-medium text-right">12 PM – 1 AM</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="flex-shrink-0">Wed–Sat</span>
                  <span className="text-neonRed font-medium text-right">12 PM – 2 AM</span>
                </div>
              </div>
              <div className="mt-4 p-3 bg-neonRed/10 rounded-lg">
                <p className="text-xs text-ivory italic" style={{fontVariant: 'small-caps'}}>
                  Pickup closes 1 hour before dining-room close
                </p>
              </div>
              <div className="mt-4 p-3 bg-neonRed/10 rounded-lg">
                <p className="text-sm text-ivory">
                  <span className="font-semibold">Late Night Menu Available 🌙</span>
                </p>
              </div>
            </div>

            {/* Contact Methods */}
            <div className="grid sm:grid-cols-2 gap-4">
              <a
                href="tel:+14162659223"
                className="p-4 border border-gray/20 rounded-lg bg-black/30 backdrop-blur-sm hover:border-neonBlue/40 transition-all duration-200 text-center"
              >
                <div className="w-10 h-10 bg-neonBlue/10 rounded-full flex items-center justify-center mx-auto mb-2">
                  <svg className="w-5 h-5 text-neonBlue" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
                <p className="text-sm text-gray">Call Us</p>
                <p className="text-neonBlue font-semibold">(416) 265-9223</p>
              </a>

              <a
                href="mailto:info@billyswingco.com"
                className="p-4 border border-gray/20 rounded-lg bg-black/30 backdrop-blur-sm hover:border-neonRed/40 transition-all duration-200 text-center"
              >
                <div className="w-10 h-10 bg-neonRed/10 rounded-full flex items-center justify-center mx-auto mb-2">
                  <svg className="w-5 h-5 text-neonRed" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <p className="text-sm text-gray">Email Us</p>
                <p className="text-neonRed font-semibold">info@billyswingco.com</p>
              </a>
            </div>
          </div>

          {/* Map & Special Features */}
          <div className="space-y-8">
            {/* Google Map */}
            <div className="h-64 lg:h-80 border border-gray/20 rounded-xl overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1440.6!2d-79.284821!3d43.763264!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f18.0!3m3!1m2!1s0x89d4d1a05b9f7b%3A0x12345678!2s3490%20Kingston%20Rd%2C%20Scarborough%2C%20ON%20M1M%201R5!5e0!3m2!1sen!2sca!4v1640995200000!5m2!1sen!2sca"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Billy's WingCo Location Map"
                className="filter grayscale hover:grayscale-0 transition-all duration-300"
              ></iframe>
            </div>

            {/* Features */}
            <div className="grid sm:grid-cols-2 gap-4">
              <div className="p-4 border border-gray/20 rounded-lg bg-black/30 backdrop-blur-sm">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-8 h-8 bg-neonBlue/10 rounded-full flex items-center justify-center">
                    <svg className="w-4 h-4 text-neonBlue" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <h4 className="text-ivory font-semibold">Reservations</h4>
                </div>
                <p className="text-gray text-sm">Call ahead for groups of 6+</p>
              </div>

              <div className="p-4 border border-gray/20 rounded-lg bg-black/30 backdrop-blur-sm">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-8 h-8 bg-neonRed/10 rounded-full flex items-center justify-center">
                    <svg className="w-4 h-4 text-neonRed" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 8h14M5 8a2 2 0 110-4h1.586a1 1 0 01.707.293l1.414 1.414a1 1 0 00.707.293H15a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
                    </svg>
                  </div>
                  <h4 className="text-ivory font-semibold">Parking</h4>
                </div>
                <p className="text-gray text-sm">Free parking available</p>
              </div>

              <div className="p-4 border border-gray/20 rounded-lg bg-black/30 backdrop-blur-sm">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-8 h-8 bg-neonBlue/10 rounded-full flex items-center justify-center">
                    <svg className="w-4 h-4 text-neonBlue" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                  </div>
                  <h4 className="text-ivory font-semibold">Sports</h4>
                </div>
                <p className="text-gray text-sm">Multiple big screens</p>
              </div>

              <div className="p-4 border border-gray/20 rounded-lg bg-black/30 backdrop-blur-sm">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-8 h-8 bg-neonRed/10 rounded-full flex items-center justify-center">
                    <svg className="w-4 h-4 text-neonRed" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                    </svg>
                  </div>
                  <h4 className="text-ivory font-semibold">Licensed</h4>
                </div>
                <p className="text-gray text-sm">Full bar & cocktails</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection; 